export function insertInputTextAtCursor(input: HTMLInputElement | HTMLTextAreaElement, text: string) {
    const value = input.value
    const start = input.selectionStart
    const end = input.selectionEnd

    if (start === null || end === null) {
        setInputNativeValue(input, value + text)
    } else {
        // insert the text at the cursor position
        setInputNativeValue(input, value.slice(0, start) + text + value.slice(end))
    }

    // Update the state with the new value
    input.dispatchEvent(new Event('input', { bubbles: true }))

    // Maintain the cursor position after insertion
    setTimeout(() => {
        if (start !== null) {
            input.setSelectionRange(start + text.length, start + text.length)
        }
        input.focus()
    }, 0)
}

function setInputNativeValue(element: HTMLInputElement | HTMLTextAreaElement, value: string) {
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value')?.set
    const prototype = Object.getPrototypeOf(element)
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set

    if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(element, value)
    } else if (valueSetter) {
        valueSetter.call(element, value)
    } else {
        element.value = value
    }
}
